




















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { bus } from "@/bus";
// components
import vSelect from "vue-select";
import FolderTree from "@/components/common/folders/FolderTree.vue";
// service methods
import { getAllTemplates } from "@/services/templates/templateService";
// types
import { Folder, FolderEntites } from "@/services/folders/types";
import { templatesModalFields } from "@/components/templates/fields/templatesModalFields";
import { Template } from "@/services/templates/types";

@Component({
    components: {
        vSelect,
        "folder-tree": FolderTree
    }
})
export default class SelectTemplateModal extends Vue {
    @Prop() id!: string;
    // local state
    templates = [] as Array<Template>;
    selectedTemplates = [] as Array<Template>
    fields = templatesModalFields;
    isBusy = false;

    // folders
    folderEntity = FolderEntites.Templates;
    selectedFolderNode = {} as Folder;
    showFolderTree = true;

    // filter
    filterWidth = "" as string;
    filterHeight = "" as string;

    // filter options
    searchText = "" as string;

    multiPicker = false;

    open(multiPicker = false) {
        this.multiPicker = multiPicker;
        this.fetchData();
        this.$bvModal.show(this.id);
    }

    select(items: Template[]) {
        this.selectedTemplates = items;
    }

    save() {
        this.$emit("select", this.selectedTemplates.map(x => {
            return {
                id: x.id,
                name: x.name
            };
        }));
        this.$bvModal.hide(this.id);
    }

    setSelectedFolder(folder: Folder) {
        this.selectedFolderNode = folder;
    }

    toggleFolderTree() {
        if (!this.filterActive) {
            this.showFolderTree = !this.showFolderTree;
        }
    }

    fetchData() {
        this.loadTemplates();
    }

    loadTemplates() {
        this.isBusy = true;
        this.templates = [] as Array<Template>;
        getAllTemplates().then(response => {
            this.templates = response;
            this.isBusy = false;
        });
    }

    clearFilter() {
        this.filterWidth = "";
        this.filterHeight = "";
        this.loadTemplates();
    }

    resetState() {
        this.searchText = "";
        this.filterWidth = "";
        this.filterHeight = "";
    }

    // computed and watchers
    get model(): Array<Template> {
        if (this.filterActive) {
            return this.templates.filter(
                x => (this.searchText === "" ? true : x.name.toLowerCase().includes(this.searchText.toLowerCase())) &&
                    (this.filterWidth === "" ? true : x.width === +this.filterWidth) &&
                    (this.filterHeight === "" ? true : x.height === +this.filterHeight)
            );
        } else {
            return this.templates.filter(
                x => this.selectedFolderNode.id ? x.folderId === this.selectedFolderNode.id : true
            );
        }
    }

    get filterActive(): boolean {
        return (
            this.searchText !== "" ||
            this.filterWidth !== "" ||
            this.filterHeight !== "");
    }

    @Watch("filterActive")
    onFilterChanged(value: any, oldValue: any) {
        this.showFolderTree = !value;
    }
}
